<template>
  <a-modal
    v-model="visible"
    :title="info.status == '3' ? '交付报告' : '查看详情'"
    @cancel="cancelModal"
    width="700px"
  >
    <div class="detail-content-body">
      <p v-if="info.consultType != '3'">
        <span>场景领域：{{ info.fieldLevelOneName }}</span>
        <span>场景应用行业：{{ info.industryLevelOneName }}</span>
        <span>技术分类：{{ info.skillLevelOneName }}</span>
      </p>
      <div v-else>
        <span>场景榜单：</span>
        <p>{{ info.sceneName }}</p>
      </div>
      <div>
        <span>咨询主题：</span>
        <p>{{ info.consultTitle }}</p>
      </div>
      <div>
        <span>{{ info.consultType == "3" ? "要求描述" : "详情描述" }}：</span>
        <p>{{ info.consultContent }}</p>
      </div>
      <div>
        <span>说明附件：</span>
        <!-- <p style="cursor: pointer" @click="downloadAnnex(info.applyAttachment.attachmentId,info.applyAttachment.fileName)">{{ info.applyAttachment != '' ? info.applyAttachment.fileName : '暂无' }}</p> -->
        <p style="cursor: pointer">
          <span v-if="info.applyAttachment == ''">暂无</span>
          <template>
            <span
              v-for="item in info.applyAttachment"
              :key="item.attachmentId"
              @click="downloadAnnex(item.attachmentId, item.fileName)"
              >{{ item.fileName }}</span
            >
          </template>
        </p>
      </div>
      <div>
        <span>联系人：</span>
        <p>{{ info.contactPerson }}</p>
      </div>
      <div>
        <span>联系电话：</span>
        <p>{{ info.contactDetail }}</p>
      </div>
      <div>
        <span>提交时间：</span>
        <p>{{ info.consultTime }}</p>
      </div>
    </div>
    <div class="detail-content-body" v-if="info.status == '3'">
      <div>
        <span>回复内容：</span>
        <p>{{ info.replyContent }}</p>
      </div>
      <div>
        <span>交付报告：</span>
        <!-- <p style="color: #1abc9c; cursor: pointer" @click="downloadAnnex(info.replyAttachment.attachmentId,info.replyAttachment.fileName)">
          {{ info.replyAttachment ? info.replyAttachment.fileName : '暂无' }}
        </p> -->
        <p style="color: #1abc9c; cursor: pointer">
          <span v-if="info.replyAttachment == ''">暂无</span>
          <template>
            <span
              v-for="item in info.replyAttachment"
              :key="item.attachmentId"
              @click="downloadAnnex(item.attachmentId, item.fileName)"
              >{{ item.fileName }}</span
            >
          </template>
        </p>
      </div>
      <div>
        <span>回复时间：</span>
        <p>{{ info.replyTime }}</p>
      </div>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="cancelModal">关闭</a-button>
    </div>
  </a-modal>
</template>

<script>
import { downloadFile } from "@/api/scene";
export default {
  props: ["show", "info"],
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    this.visible = this.show;
  },
  watch: {
    show: function (val) {
      this.visible = val;
    },
  },
  methods: {
    cancelModal() {
      this.$emit("input", false);
    },
    downloadAnnex(id, name) {
      downloadFile(id).then((res) => {
        if (!res) {
          return;
        }
        let url = window.URL.createObjectURL(new Blob([res]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", name);
        document.body.appendChild(link);
        link.click();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.detail-content-body {
  font-size: 14px;
  color: #262626;
  > p {
    display: flex;
    margin-bottom: 12px;
    > span {
      line-height: 14px;
      margin-right: 20px;
    }
  }
  > div {
    display: flex;
    margin-bottom: 12px;
    > span {
      white-space: nowrap;
      margin-right: 10px;
      line-height: 24px;
      width: 70px;
    }
    > p {
      flex: 1;
      margin-bottom: 0;
      line-height: 24px;
    }
  }
}
.detail-status-body {
  display: flex;
  color: #262626;
  > span {
    white-space: nowrap;
    margin-right: 10px;
    line-height: 24px;
    width: 70px;
  }
  > div {
    flex: 1;
    .detail-status-desc {
      margin-top: 12px;
      textarea {
        height: 100px;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
